<template>
    <aside class="c-side-menu">
        <nav class="c-side-menu__nav">
            <ul class="c-side-menu__ul">
                <li class="c-side-menu__li" v-for="(SideMenuLink, index) in SideMenuLinks" :key="`SideMenulink-${index}`">
                    <router-link class="c-side-menu__a" :to="SideMenuLink.route">
                        {{ $t(SideMenuLink.title) }}
                    </router-link>
                </li>
            </ul>
        </nav>
    </aside>
</template>

<script>
    export default {
        props: ['SideMenuLinks'],
        computed: {
            isPersoneel() {
                return this.$store.getters.isPersoneel;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-side-menu {

        &__nav {
            background-color: #F4F5F6;
            padding: 25px 0;
        }
        &__ul {
            margin: 0;
            padding-left: 0;
            list-style-type: none;
        }
        &__li {
        }
        &__a {
            color: inherit;
            text-decoration: none;
            position: relative;
            padding: (1em / 3) 2em;
            border-left: solid 2px transparent;
            display: inline-block;
            font-weight: 500;
            @include rfs(17);
            font-style: italic;

            &:focus,
            &:hover,
            &.router-link-active {
                color: $color-alpha;
            }

            &.router-link-active {
                color: $color-alpha;
                border-color: currentColor;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/SideMenu.vue